module.exports = "\n#include <common>\n\nvarying vec4 particleVel;\n\nvoid main() {\n\n  vec4 rainbow = particleVel;\n\n  vec4 outputColor = vec4(\n  \trainbow.x + 0.6,\n  \t(rainbow.y * rainbow.x) + 0.6,\n  \trainbow.y + 0.6,\n  \t0.2\n  );\n\n  gl_FragColor = outputColor;\n\n  // gl_FragColor = vec4( vec3(0.0,0.0,1.0) , 0.5);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/components/Prototypes/Visual/ParticleSea/ParticleShader/fragmentShader.frag
// module id = 464
// module chunks = 0